import type { OfferedServiceStatus } from "@bookdental/schemas";

export const SERVICE_STATUS_META: Record<
  OfferedServiceStatus,
  { label: string; color: string; bg: string }
> = {
  ACTIVE: { label: "Ativo", color: "#059669", bg: "#10b98114" },
  INACTIVE: { label: "Inativo", color: "#71717a", bg: "#71717a14" },
};

/** Centavos → "R$ 1.234,56". `null` (preço oculto pra quem não é OWNER) vira "—". */
export function formatPriceCents(cents: number | null): string {
  if (cents == null) return "—";
  return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

/** "150,00" / "150.00" / "150" / "R$ 150,00" → centavos inteiros. */
export function parsePriceInput(v: string): number {
  // Tira símbolo e espaço antes de tudo: o campo às vezes chega já formatado ("R$ 4,15"), e colar
  // valor de outra tela é comum. Sem isto, `Number` dá NaN e o preço vira zero em silêncio — o
  // pior desfecho possível, porque parece que funcionou.
  const normalized = v
    .replace(/[^\d.,-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".")
    .trim();
  const n = Number(normalized);
  return Number.isFinite(n) ? Math.round(n * 100) : 0;
}

/** Minutos → "40 min" / "1h30min". */
export function formatDuration(minutes: number | null | undefined): string {
  if (!minutes) return "";
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h${m}min` : `${h}h`;
}
